import { gql } from '@apollo/client';

export const DELETE_DRAFT_MUTATION = gql`
    mutation deleteDraft($id: String!, $userId: String!) {
        deleteDraft(id: $id, userId: $userId)
    }
`;
